import { atom } from "recoil";

export const noticeDisplayed = atom({
  key: "noticeDisplayed", // unique ID (with respect to other atoms/selectors)
  default: false, // default value (aka initial value)
});
